import React, { Fragment} from 'react';
import logo from '../../assets/img/logo/logo-smart.png'
import styles from '../../assets/css/module/common/common.module.css';
const LoadingScreen = () => {
  return (
    <Fragment>
      <div className={`${styles['loading-screen']} ${styles['zoom-in-out-element']}`}>
        <img src={logo} alt='' className={` ${styles['zoom-in-out-element']}`}/>
      </div>
    </Fragment>
  );
}

export default LoadingScreen;